<template>
  <div>
    <div class="price-range" id="price-range" style="padding: 0px 15px;
    position: relative;
    margin: 20px 0;
    border-bottom: 2px solid #ea7819;">
      <div id="price-histogram-wrapper">
        <div v-if="histogram" class="histogram">
          <div v-for="(height, offset) of barHeights"
               :key="offset"
               :style="{'height': height + '%' }"
          ></div>
        </div>
      </div>
      <div ref="slider" class="price-range-slider"></div>
    </div>
    <div style="display: flex; width: 100%; gap: 15px;">
      <div>
        <label>Von</label>
        <div style="position:relative;">
          <input type="text"
                 style="flex: 1 1 0;width: 100%;text-align: center;padding-right: 20px; height: 42px;"
                 :value="range[0]"
                 @change="updateRangeStart($event.target.value)"
          >
          <div class="input-addon">€</div>
        </div>
      </div>
      <div>
        <label>Bis</label>
        <div style="position:relative;">
          <input type="text"
                 style="flex: 1 1 0;width: 100%;text-align: center;padding-right: 20px; height: 42px;"
                 :value="range[1]"
                 @change="updateRangeEnd($event.target.value)"
          >
          <div class="input-addon">€</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import * as noUiSlider from 'nouislider';

function mergeTooltips(slider, threshold, separator) {

  var textIsRtl = getComputedStyle(slider).direction === 'rtl';
  var isRtl = slider.noUiSlider.options.direction === 'rtl';
  var isVertical = slider.noUiSlider.options.orientation === 'vertical';

  var origins = slider.noUiSlider.getOrigins();

  // Move tooltips into the origin element. The default stylesheet handles this.

  slider.noUiSlider.on('update', function (values, handle, unencoded, tap, positions) {

    var pools = [[]];
    var poolPositions = [[]];
    var poolValues = [[]];
    var atPool = 0;

    var tooltips = slider.noUiSlider.getTooltips();
    var formatters = slider.noUiSlider.options.tooltips;
    tooltips.forEach(function (tooltip, index) {
      if (tooltip) {
        origins[index].appendChild(tooltip);
      }
    });

    // Assign the first tooltip to the first pool, if the tooltip is configured
    if (tooltips[0]) {
      pools[0][0] = 0;
      poolPositions[0][0] = positions[0];
      poolValues[0][0] = formatters[0] ? formatters[0].to(unencoded[0]) : values[0];
    }

    for (var i = 1; i < positions.length; i++) {
      if (!tooltips[i] || (positions[i] - positions[i - 1]) > threshold) {
        atPool++;
        pools[atPool] = [];
        poolValues[atPool] = [];
        poolPositions[atPool] = [];
      }

      if (tooltips[i]) {
        pools[atPool].push(i);
        poolValues[atPool].push(formatters[i] ? formatters[i].to(unencoded[i]) : values[0]);
        poolPositions[atPool].push(positions[i]);
      }
    }

    pools.forEach(function (pool, poolIndex) {
      var handlesInPool = pool.length;

      for (var j = 0; j < handlesInPool; j++) {
        var handleNumber = pool[j];

        if (j === handlesInPool - 1) {
          var offset = 0;

          poolPositions[poolIndex].forEach(function (value) {
            offset += 1000 - 10 * value;
          });

          var direction = isVertical ? 'bottom' : 'right';
          var last = isRtl ? 0 : handlesInPool - 1;
          var lastOffset = 1000 - 10 * poolPositions[poolIndex][last];
          offset = (textIsRtl && !isVertical ? 100 : 0) + (offset / handlesInPool) - lastOffset;

          // Center this tooltip over the affected handles
          tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator);
          tooltips[handleNumber].style.display = 'block';
          tooltips[handleNumber].style[direction] = offset + '%';
        } else {
          // Hide this tooltip
          tooltips[handleNumber].style.display = 'none';
        }
      }
    });
  });
}

export default {
  name: "PriceRange",
  props: {
    histogram: Object,
  },
  data: () => ({
    range: [0, 3000]
  }),

  computed: {
    barHeights() {
      if (!this.histogram) {
        return [];
      }
      const max = this.histogram.data
          .reduce((max, value) => Math.max(max, value) , 0);
      if (max === 0) {
        return [];
      }
      return this.histogram.data.map(value => Math.round(value / max * 100));
    }
  },

  methods: {

    updateRangeStart(value) {
      value = parseInt(value);
      if (Number.isNaN(value)) {
        value = 0;
      }
      if (value < 0) {
        value = 0;
      }
      if (value > 3000) {
        value = 3000;
      }
      this.range = [value, this.range[1]];
      this.$refs.slider.noUiSlider.set(this.range, );
    },

    updateRangeEnd(value) {
      value = parseInt(value);
      if (Number.isNaN(value)) {
        value = 3000;
      }
      if (value < 0) {
        value = 0;
      }
      if (value > 3000) {
        value = 3000;
      }
      this.range = [this.range[0], value];
      this.$refs.slider.noUiSlider.set(this.range);
    },


  },

  mounted() {
    var formatter = {
      to: function (value) {
        return value.toFixed(0) + '€';
      },
      from: function (value) {
        return parseInt(value.replace('€', ''));
      }
    };
    var slider = noUiSlider.create(this.$refs.slider, {
      start: [0,3000],
      connect: [true, false, true],
      tooltips: [formatter, formatter],
      step: 50,
      margin: 50,
      range: {
        'min': [0, 50],
        // '10%': [100, 10],
        // '50%': [1000, 10],
        'max': [3000, 50]
      }
    });
    var oldValues = [];
    var minMax = [0,3000];

    slider.on('update', function (values, handle, unencoded) {
      if (
          oldValues[handle] !== unencoded[handle]
          && (
              oldValues[handle] === minMax[handle]
              || unencoded[handle] === minMax[handle]
          )
      ) {
        console.log('setTooltips',[
          unencoded[0] === minMax[0] ? false : formatter,
          unencoded[1] === minMax[1] ? false : formatter
        ]);
        // setTimeout(function () {
        //     self.updateOptions({tooltips: [
        //             unencoded[0] === minMax[0] ? false : formatter,
        //             unencoded[1] === minMax[1] ? false : formatter
        //         ]}, false);
        // }, 0);
      }
      //console.log('slider-update', handle, unencoded[handle], oldValues[handle]);
      oldValues = unencoded;
    });

    slider.on('set', (values, handle, unencoded) => {
      const range = unencoded.map(Math.round);
      this.range = range;
      this.$emit('update:range', range);
    });

    mergeTooltips(this.$refs.slider, 15, ' - ')
  }
}
</script>

<style lang="scss">
  @import '~nouislider/distribute/nouislider.min.css';

  .histogram {
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: stretch;
    align-items: flex-end;

    &>* {
      flex: 1 1 auto;
      background-color: #EA7819;
    }
  }

  .input-addon {
    position: absolute;
    top: 0px;
    right: 0;
    color: #666;
    padding: .75em;
    font-size: 14px;
    line-height: 1.4rem;
    height: 42px;
    font-family: 'Open Sans',sans-serif;
    font-weight: 400;
    background: #eaeaea;
    border-width: 1px;
    border-style: solid;
    border-color: #eaeaea;
    border-radius: 2px;
  }

  .price-range-slider.noUi-target {
    position: absolute;
    top: 0;
    left: 15px;
    right: 15px;
    height: 100%;
    background: none;
    border: none;
    box-shadow: none;
  }

  .price-range-slider .noUi-connect {
    background: #000000;
    opacity: 0.2;
    border-radius: 0;
    box-shadow: none;
    border: none;
  }

  .price-range-slider.noUi-horizontal .noUi-origin {
    top: 100%;
  }

  .price-range-slider.noUi-horizontal .noUi-handle {
    width: 15px;
    height: 30px;
    top: -15px;
    border: none;
    border-radius: 0;
    box-shadow: none;
    background-color: transparent;
  }

  .price-range-slider.noUi-horizontal .noUi-handle:after {
    content: "";
    display: block;
    position: absolute;
    height: 0px;
    width: 0;
    background: transparent;
    left: -1px;
    top: 1px;
    border-style: solid;
  }

  .price-range-slider.noUi-horizontal .noUi-handle.noUi-handle-lower:after {
    border-width: 15px;
    border-color: transparent;
    border-left-color: #ea7819;
    border-right-width: 0;
  }

  .price-range-slider.noUi-horizontal .noUi-handle.noUi-handle-upper:after {
    border-width: 15px;
    border-color: transparent;
    border-right-color: #ea7819;
    border-left-width: 0;
  }

  .price-range-slider.noUi-horizontal .noUi-handle:before {
    display: none;
  }

  .price-range-slider.noUi-horizontal .noUi-tooltip {
    border: none;
    border-radius: initial;
    background: transparent;
    color: #fff;
    text-align: center;
    white-space: nowrap;
  }

  .price-range-slider.noUi-horizontal .noUi-handle-upper {
    right: -15px;
  }

  .price-range-slider.noUi-horizontal .noUi-handle-lower {
    right: 0px;
  }

</style>
